@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  <p>{{ communicationDirection[$.row![$.adata.fetch_key]] }}</p>
}
